import {Component, OnInit, OnDestroy} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {NgRedux} from '@angular-redux/store';
import {PermissionActions} from '../../../app.actions';
import {IAppState} from '../../../interfaces/appstate.interface';

declare var jQuery: any;
declare var $: any;
declare var dialogCreate: any;
declare var dialogOpen: any;
declare var defaultChartExposureSettings;

@Component({
  selector: 'hedge',
  templateUrl: './hedge.component.html',
  styleUrls: ['./hedge.component.css'],
})

export class HedgeBranch implements OnInit, OnDestroy {

  private token: any;
  private subscription: any;

  constructor(private route: ActivatedRoute, private titleService: Title, private ngRedux: NgRedux<IAppState>, private actions: PermissionActions) {
    this.subscription = ngRedux.select("token").subscribe((res) => {
      this.token = res;
    })
  }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | Currency and Funding Exposure");

    /*<![CDATA[*/
    var mainNav = "exposure-nav";
    var sideNav = "side-nav-risk-hedge";


    jQuery(document).ready(() => {

      dialogCreate('#confirmHedgeNowTarget', () => {
        jQuery.ajax({
          url: "/ajax/hedging",
          type: 'PUT',
          success: (data, textStatus, jqXHR) => {
            if (jqXHR.status == 200) {
              var chart = jQuery('#exposureByPercentage').jqxChart('source');
              if (chart !== undefined) chart.dataBind();
              chart = jQuery('#exposureByCcyEquivalent').jqxChart('source');
              if (chart !== undefined) chart.dataBind();
            }
          }
        });
      });

      dialogCreate('#confirmHedgeNow100', () => {
        jQuery.ajax({
          url: "/ajax/hedging",
          type: 'PUT',
          data: {hedgingFully: true},
          success: (data, textStatus, jqXHR) => {
            if (jqXHR.status == 200) {
              var chart = jQuery('#exposureByPercentage').jqxChart('source');
              if (chart !== undefined) chart.dataBind();
              chart = jQuery('#exposureByCcyEquivalent').jqxChart('source');
              if (chart !== undefined) chart.dataBind();
            }
          }
        });
      });

      jQuery("#hedgeNowToTarget").click(() => {
        dialogOpen('#confirmHedgeNowTarget');
      });

      jQuery("#hedgeNow100").click(() => {
        dialogOpen('#confirmHedgeNow100');
      });

      var chartDataRefresh = (records) => {
        jQuery('#jqxExposureTabs').jqxTabs({height: records.length * 60 + 100});
        jQuery('#jqxExposureTabs').jqxTabs("refresh");
      };

      var initExposureByPercentage = () => {
        var source = {
          url: '/ajax/hedging?sortBy=percentage&groupBy=currencyPair',
          type: 'GET',
          async: true
        };
        var settings = defaultChartExposureSettings('#exposureByPercentage', source, "Percentage", "Hedged", true, chartDataRefresh);
        settings.showBorderLine = false;
        jQuery('#exposureByPercentage').jqxChart(settings);
      };

      var initExposureByCcyEquivalent = () => {
        var source = {
          url: '/ajax/hedging?sortBy=ccy&groupBy=currencyPair',
          type: 'GET',
          async: true
        };
        var settings = defaultChartExposureSettings('#exposureByCcyEquivalent', source, "BaseQuantity", "Hedged", false, chartDataRefresh);
        settings.showBorderLine = false;
        jQuery('#exposureByCcyEquivalent').jqxChart(settings);
      };

      var initExposureTabs = (tab) => {
        switch (tab) {
          case 0:
            initExposureByPercentage();
            break;
          case 1:
            initExposureByCcyEquivalent();
            break;
        }
      }

      var initTabs = function () {
        var tabContainer = $('#jqxExposureTabs');
        if (tabContainer.length) {
          tabContainer.jqxTabs({
            width: 750,
            height: 500,
            initTabContent: initExposureTabs
          });
        } else {
          setTimeout(function () {
            initTabs();
          }, 100);
        }
      };
      initTabs();
    });

    /*]]>*/
  }

  ngOnDestroy() {
    $('#contentDiv').parent().remove();
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/exposure/hedge/hedge.component.ts